export let isDeferred = function <T>(x: T | PromiseLike<T>): x is JQueryPromise<T>
{
    return (x as any) && typeof (x as any).done === "function";
}